const getBadgeVariant = (achievementStatus) => {
  switch (achievementStatus?.toLowerCase()) {
    case 'achievement belum tersedia':
      return 'default';
    case 'achievement tersedia':
      return 'success';
    default:
      return 'warn';
  }
};

export default getBadgeVariant;
